<template>
<div class="animated fadeIn">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>검사결과 상세</strong> <small style="float:right;">점검일시 {{model.scan_time | datetime}}</small>
          </div>
          <b-row>
            <b-col md="10">
              <b-form-group>
                <label for="ph_agent" v-b-tooltip.hover>에이전트</label><br>
                <label for="ph_agent" v-if="model && model.agent">{{`${model.agent.name} (${model.agent.host}@${model.agent.ip_addr})`}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ph_folder" v-b-tooltip.hover>점검폴더</label><br>
                <label for="ph_folder">{{model.scan_folder}}개 점검</label>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_check" v-b-tooltip.hover>점검파일</label><br>
                <label for="ph_check">{{model.scan_count}}개 점검</label>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_webshell" v-b-tooltip.hover>탐지결과</label><br>
                <label for="ph_webshell"> {{model.detect_count}}개 점검</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_detect" v-b-tooltip.hover>탐지내역</label><br>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row >
            <b-col md="12">
              <b-form-group>
                <pre style="background-color:#f5f5f5; border:1px solid #ccc; padding:10px; max-height: 500px; max-width: 1500px; overflow: auto;">{{detect_list}}</pre>
              </b-form-group>
            </b-col>
          </b-row>
          <b-button size="sm" variant="success" @click="save_rs"> 다운로드 </b-button>
          <b-button size="sm" class="float-right" variant="primary" @click="list"> 목록으로 </b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Api } from '@/service';
import { saveAs } from 'file-saver/FileSaver';

export default {
  data : () => { return { model : {}, detect_list : "", } },
  methods: {
    save_rs() {
      let data = _.map(this.model.detect_list, x => { return x+='\r\n'; })
      if(!data.length) { this.$toastr.i('탐지된 웹쉘 목록이 없습니다'); return; }
      let blob = new Blob(data, {type: "text/plain;charset=utf-8"});
      saveAs(blob, 'webshell_list.txt');
    },
    list() { this.$router.push({ name: 'wsfinder_result'}); },
    async get({ id } = this.$route.params) {
      console.log('result.detail.vue', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; this.model = default_model(); return; }
      try {
        let rs = await Api.WSFinder_Call('result', 'detail', {id : id})
        this.model = Object.assign({ group: {} }, this.model, rs.body)
        this.detect_list = _.join(this.model.detect_list, '\r\n')
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('result.detail.vue', 'created'); },
  destroyed: function() { console.log('result.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('result.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
